import {Injectable} from '@angular/core';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import {Actions, Effect} from '@ngrx/effects';

import * as windowActions from './../actions/windows.actions';
import {Observable} from 'rxjs/Observable';
import {ProductService} from '../shared/product.service';

@Injectable()
export class WindowEffects {

  constructor(
    private productService: ProductService,
    private actions$: Actions
  ) { }

  @Effect()
  loadWindows$: Observable<windowActions.WindowAction> = this.actions$ 
    .ofType(windowActions.LOAD_WINDOWS)
    .switchMap(() => {
        return this.productService.getWindowsFromBackend()
          .map( windows => new windowActions.LoadWindowsSuccessAction(windows));
      }
    );
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/effects/window.effects.ts